module.exports = __webpack_public_path__ + "media/images/top/feature_img_03_pc-f10be45ea1c4294dcdd5bd2d82bdbedc.png";